module.exports = __webpack_public_path__ + "img/logo-sena-naranja.d8b9a0f4.svg";